import React from 'react';
import VideoPlayer from '../../components/videoPlayer';
import useVideoTestimonialStyle from './styles';

const SingleVideoSlide = (props) => {
  const { data } = props;
  const classes = useVideoTestimonialStyle();
  return (
    <div className={classes.videoCarouselContainer}>
      <div className={classes.videoCarousel}>
        <div className={classes.iframeSuperContainer}>
          <div
            ref={data?.videoFrame?.refSetter}
            className={classes.iframeContainer}
          >
            <VideoPlayer
              imageUrl={data.videoFrame.metadata?.thumbnail}
              videoUrl={data.videoFrame.metadata?.value}
              sectionIndex={props?.sectionIndex}
            />
          </div>
        </div>

        <div className={classes.videoDetails}>
          <h3
            ref={data?.videoTextHeading?.refSetter}
            className={classes.videoDetailsHeading}
            dangerouslySetInnerHTML={{
              __html: data.videoTextHeading.metadata.value
            }}
          />
          <p
            ref={data?.videoTextContent?.refSetter}
            className={classes.videoDetailsContent}
            dangerouslySetInnerHTML={{
              __html: data.videoTextContent.metadata.value
            }}
          />
          <p
            ref={data?.videoTextSubContent?.refSetter}
            className={classes.videoDetailsSubContent}
            dangerouslySetInnerHTML={{
              __html: data.videoTextSubContent.metadata.value
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SingleVideoSlide;
